import Dropdown from "../../../common/dropdown";
import Accordion from "../../../common/accordion";
import TableComponent from "../../../common/TableComponent";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import { useEffect, useState } from "react";
import useProtectorFacade from "../../../../facade/calculation/calculation-output/protector.facade";
import { Protector300Series, Protector400Series, Protector500Series, ProtectorDto, ProtectorListProps } from "../../../../store/model/calculations/protector";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";


const ProtectorList: React.FC<ProtectorListProps> = ({ showError, setShowError }) => {

  const [listData, setListData] = useState<any[]>([]);
  const [showWarningMessage, setShowWarningMessage] = useState<boolean>(false);
  const { tab1Input } = useAppSelector((state) => state?.tubing);
  const { protectorListCollapse } = useAppSelector((state) => state?.collapse);
  const {
    ProtectorListSeries,
    protectorSeries,
    ProtectorList,
    selectedLowerProtector,
    selectedUpperProtector
  } = useAppSelector((state) => state?.protector)
  const { SelectedMotor } = useAppSelector((state) => state?.motor);

  const { updateProtectorListCollapse } = useCollapseFacade();
  const {
    updateProtectorSeries,
    loadSelectedProtector,
  } = useProtectorFacade();

  const { updatehiddenProtector1, updateHiddenProtector2 } = useTubingFacade();

  let seriesList: { id: string; name: string }[] = [
    { id: "0", name: "ALL" },
    ...Object.entries(ProtectorListSeries || [])
      .map(([key, value]) => ({ id: key, name: value as string }))
  ];

  const protectorTableColumns = [
    {
      title: "Series",
      dataIndex: "series",
      key: "series",
      sortable: false,
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      sortable: false,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sortable: false,
    },
    {
      title: `Std shaft rating ${tab1Input?.actNameProtector_ShaftRating || 'hp'}`,
      dataIndex: "stdShaftHP",
      key: "stdShaftHP",
      sortable: false,
    },
    {
      title: `HS shaft rating ${tab1Input?.actNameProtector_ShaftRating || 'hp'}`,
      dataIndex: "hsShaftHP",
      key: "hsShaftHP",
      sortable: false,
    },
    {
      title: `Housing Dia ${tab1Input?.unitSys == 0 ? "in" : "mm"}`,
      dataIndex: "housingDiaIn",
      key: "housingDiaIn",
      sortable: false,
    },
    {
      title: `Power ${tab1Input?.actNameProtector_ShaftRating || 'hp'}`,
      dataIndex: "hp",
      key: "hp",
      sortable: false,
    },
    {
      title: `Temp Rating ${tab1Input?.actNameMotor_TOperatingTemp}`,
      dataIndex: "tempetaureRating",
      key: "tempetaureRating",
      sortable: false,
    },
  ];

  useEffect(() => {
    const series = SelectedMotor?.series;
    const matchingProtector = seriesList?.find((item: any) => item?.id?.includes(series));

    if (matchingProtector) {
      const seriesFilterText = matchingProtector;
      updateProtectorSeries(seriesFilterText?.id);
    }
  }, []);

  useEffect(() => {
    if (protectorSeries !== "0") {
      let val = ProtectorList?.filter((item: any) => item.series === protectorSeries)
      setListData(val || [])
    } else {
      setListData(ProtectorList || [])
    }
  }, [protectorSeries, ProtectorList]);

  useEffect(() => {
    if (ProtectorListSeries?.length > 0) {
      const protecter400Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector400Series.includes(x));
      const protecter300Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector300Series.includes(x));
      const protecter500Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector500Series.includes(x));

      let showInCompatibleWarningMessage = false;

      if (protecter300Series.includes(selectedLowerProtector?.series) && showWarningMessage) {
        updatehiddenProtector1('');
        showInCompatibleWarningMessage = true;
      }

      if (protecter500Series.includes(selectedLowerProtector?.series) && showWarningMessage) {
        updatehiddenProtector1('');
        showInCompatibleWarningMessage = true;
      }

      if (protecter400Series.includes(selectedLowerProtector?.series)) {
        if (selectedUpperProtector) {
          if (selectedUpperProtector?.series !== Protector400Series[0]) {
            updateHiddenProtector2('');
            showInCompatibleWarningMessage = true;
          }
        }

        if (selectedLowerProtector) {
          if (selectedLowerProtector?.series === Protector400Series[0]) {
            updatehiddenProtector1('');
            showInCompatibleWarningMessage = true;
          }
        }
      }

      if (showInCompatibleWarningMessage) {
        if (!showError?.includes("Upper and Lower protectors not compatible"))
          setShowError((prevState: any) => [...prevState, "Upper and Lower protectors not compatible"]);
        return;
      } else {
        setShowError((prevState: any) =>
          prevState.filter((error: any) => error !== "Upper and Lower protectors not compatible")
        );
      }
    }
  }, [ProtectorListSeries, selectedUpperProtector, selectedLowerProtector, showWarningMessage]);

  const handleCollapseChange = (key: boolean) => {
    updateProtectorListCollapse(key);
  };

  const handleSelect = (option: any) => {
    updateProtectorSeries(option?.id)
    if (option?.id === "0") {
      setListData(ProtectorList || [])
      return
    }
    let val = ProtectorList?.filter((item: any) => item.series === option?.id)
    setListData(val || [])

    let series = option?.id?.split("/");
    setShowWarningMessage((series && !(+series[0] === +(SelectedMotor?.series ?? 0) || +series[1] === +(SelectedMotor?.series ?? 0))));


    setShowError((prevState: any) =>
      prevState.filter((error: any) => error !== "Upper and Lower protectors not compatible")
    );
    if (series && !(+series[0] === +(SelectedMotor?.series ?? 0) || +series[1] === +(SelectedMotor?.series ?? 0))) {
      if (!showError?.includes("Protector and Motor Series are not same"))
        setShowError((prevState: any) => [...prevState, "Protector and Motor Series are not same"]);
      return;
    } else {
      setShowError((prevState: any) =>
        prevState.filter((error: any) => error !== "Protector and Motor Series are not same")
      );
    }
  };

  const handleClickRow = (item: ProtectorDto) => {

    const protecter400Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector400Series.includes(x));
    const protecter300Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector300Series.includes(x));
    const protecter500Series = Object.values(ProtectorListSeries)?.filter((x: any) => Protector500Series.includes(x));
    const protecter400UTSeries = Protector400Series[0];

    const protecterFilterSeries = protectorSeries;
    let showInCompatibleWarningMessage = false;

    if (protectorSeries) {
      if (protecter400Series.includes(selectedLowerProtector?.series) &&
        (item?.series !== protecter400UTSeries)) {
        showInCompatibleWarningMessage = true;
      }

      if (protecter300Series.includes(selectedLowerProtector?.series) &&
        protecter400Series.includes(item?.series)) {
        showInCompatibleWarningMessage = true;
      }

      if (protecter500Series.includes(selectedLowerProtector?.series) &&
        protecter400Series.includes(item?.series)) {
        showInCompatibleWarningMessage = true;
      }

      if (protecter300Series.includes(selectedLowerProtector?.series) &&
        protecter500Series.includes(item?.series)) {
        showInCompatibleWarningMessage = true;
      }

      if (protecter500Series.includes(selectedLowerProtector?.series) &&
        protecter300Series.includes(item?.series)) {
        showInCompatibleWarningMessage = true;
      }
    }

    if (!protecterFilterSeries && showWarningMessage) {
      const series = item?.series?.split("/");
      if (series && (series[0] !== tab1Input.motorSeries || series[1] !== tab1Input.motorSeries)) {
        showInCompatibleWarningMessage = true;
      }
    }

    if ((selectedLowerProtector === undefined || Object.keys(selectedLowerProtector).length === 0) && showWarningMessage) {
      showInCompatibleWarningMessage = true;
    }

    if (showInCompatibleWarningMessage) {
      if (!showError?.includes("Upper and Lower protectors not compatible"))
        setShowError((prevState: any) => [...prevState, "Upper and Lower protectors not compatible"]);
      return;
    } else {
      setShowError((prevState: any) =>
        prevState.filter((error: any) => error !== "Upper and Lower protectors not compatible")
      );
    }

    loadSelectedProtector(item);
  };

  return (
    <>
      <Accordion
        title="Protectors list @ 60Hz"
        text={`No. of records: ${listData?.length || 0}`}
        isOpen={protectorListCollapse}
        onToggle={() => handleCollapseChange(!protectorListCollapse)}
        content={
          <div className="p-[16px] flex flex-col">
            <div className="flex items-center gap-[12px] pb-[16px]">
              <label className="text-[14px] font-semibold text-neutral-25">
                Protector series
              </label>
              <Dropdown
                options={seriesList || []}
                onSelect={(option) => handleSelect(option)}
                dropdownBgColor="bg-darkcolor-800"
                bgColor="bg-transparent"
                width="170px"
                selected={protectorSeries}
              />
            </div>
            <TableComponent
              data={listData || []}
              rowsPerPage={1}
              columns={protectorTableColumns}
              emptyIcon={false}
              pagination={false}
              pageNumber={1}
              height={465}
              overFlowClass={"overflow-auto"}
              clickableRows={true}
              name="protectorList"
              protectorID={[selectedLowerProtector?.protectorID, selectedUpperProtector?.protectorID]}
              onRowClick={(item) => handleClickRow(item)}
            />
          </div>
        }
      />
    </>
  );
};

export default ProtectorList;
